module.exports = __webpack_public_path__ + "static/media/8@1920w.8f9414cd.jpg";